import React from "react";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

export interface ReasonOption {
  key: string;
  value: string;
  dataAnchor: string;
  dataTestId: string;
  label: string;
}

export const DEFAULT_REASON_OPTIONS: ReasonOption[] = [
  {
    key: "unpaid-account-disable",
    value: "Unpaid Account / Dispute",
    dataAnchor: "reason-unpaid-option",
    dataTestId: "reason-unpaid-option",
    label: "Unpaid Account / Dispute",
  },
  {
    key: "org-merge-split",
    value: "Org Merge/ Split",
    dataAnchor: "reason-mergesplit-option",
    dataTestId: "reason-mergesplit-option",
    label: "Org Merge / Split",
  },
  {
    key: "other-request-from-customer",
    value: "Other Request from Customer",
    dataAnchor: "reason-othercustomer-option",
    dataTestId: "reason-othercustomer-option",
    label: "Other Request from Customer",
  },
  {
    key: "other-request-from-gtm",
    value: "Other Request from GTM",
    dataAnchor: "reason-othergtm-option",
    dataTestId: "reason-othergtm-option",
    label: "Other Request from GTM",
  },
];

export interface ReasonDropdownProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  id: string;
  labelId: string;
  options?: ReasonOption[];
  dataAnchorPrefix?: string;
  dataTestIdPrefix?: string;
}

const ReasonDropdown: React.FC<ReasonDropdownProps> = ({
  value,
  onChange,
  label,
  id,
  labelId,
  options = DEFAULT_REASON_OPTIONS,
  dataAnchorPrefix = "",
  dataTestIdPrefix = "",
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  const getDataAttribute = (
    option: ReasonOption,
    prefix: string,
    type: "anchor" | "testId",
  ) => {
    const attributeKey = type === "anchor" ? "dataAnchor" : "dataTestId";
    return prefix ? `${prefix}-${option[attributeKey]}` : option[attributeKey];
  };

  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        required
        fullWidth
        labelId={labelId}
        id={id}
        label={label}
        onChange={handleChange}
        value={value}
        inputProps={{ "data-testid": `${dataTestIdPrefix}-select-item` }}
        data-anchor={`${dataAnchorPrefix}-reason-select`}
        data-testid={`${dataAnchorPrefix}-reason-select`}
      >
        {options.map((option) => (
          <MenuItem
            key={option.key}
            value={option.value}
            data-anchor={getDataAttribute(option, dataAnchorPrefix, "anchor")}
            data-testid={getDataAttribute(option, dataAnchorPrefix, "testId")}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ReasonDropdown;
